import React, { useState, useEffect } from 'react';
import { post } from '../services/api';
import PowerfulTable from './PowerfulTable/PowerfulTable';

const ServerList = ({ title, defaultUrl, isNewServer }) => {
  const [url, setUrl] = useState(defaultUrl);
  const [token, setToken] = useState(localStorage.getItem('AUTH_HEADER') || '');
  const [pupils, setPupils] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchPupils = async () => {
    setLoading(true);
    setError(null);
    try {
      let fetchUrl = url.trim();
      if (!fetchUrl.startsWith('http://') && !fetchUrl.startsWith('https://')) {
        fetchUrl = fetchUrl.includes('test.expliquemoipythagore.fr') || fetchUrl.includes('https') ? `https://${fetchUrl}` : `http://${fetchUrl}`;
      }
      
      const response = await post('/admin/proxy', {
        url: `${fetchUrl}/admin/pupils?limit=10000`,
        token: token
      });
      
      if (response && !response.message) {
        setPupils(response);
      } else if (response && response.message) {
        setError(response.message);
      }
    } catch (err) {
      console.error('Error fetching pupils from', url, err);
      setError('Failed to fetch data');
    } finally {
      setLoading(false);
    }
  };

  const triggerMigration = async () => {
    const confirmation = window.prompt("⚠️ DANGER ⚠️\nCela va EFFACER toute la base de données actuelle et relancer l'import.\nTapez exactement 'YES_DELETE_EVERYTHING_AND_REMIGRATE' pour confirmer :");
    if (confirmation === 'YES_DELETE_EVERYTHING_AND_REMIGRATE') {
      try {
        setLoading(true);
        
        // Appel DIRECT au backend sur lequel on est connecté (pas de proxy)
        const response = await post('/admin/system/clear-and-remigrate', {
          confirm: confirmation
        });

        if (response && !response.message) {
          alert('Migration started / completed successfully! Check server logs.');
        } else if (response && response.message) {
          alert('Response: ' + response.message + (response.details ? '\n' + response.details : ''));
        }
      } catch (err) {
        alert('Migration trigger failed: ' + String(err));
      } finally {
        setLoading(false);
      }
    } else if (confirmation !== null) {
      alert('Confirmation annulée ou incorrecte.');
    }
  };

  useEffect(() => {
    fetchPupils();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ flex: 1, margin: '0 10px', display: 'flex', flexDirection: 'column' }}>
      <h3>{title}</h3>
      <div style={{ display: 'flex', marginBottom: 15, flexDirection: 'column', gap: 10 }}>
        <div style={{ display: 'flex' }}>
          <input 
            type="text" 
            value={url} 
            onChange={(e) => setUrl(e.target.value)} 
            style={{ flex: 1, padding: '8px', borderRadius: '4px', border: '1px solid #ccc', marginRight: '10px' }}
            placeholder="Server URL or IP"
          />
          <button 
            onClick={fetchPupils}
            style={{ padding: '8px 15px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
          >
            Refresh
          </button>
        </div>
        <div style={{ display: 'flex' }}>
          <input 
            type="text" 
            value={token} 
            onChange={(e) => setToken(e.target.value)} 
            style={{ flex: 1, padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
            placeholder="Auth Token (Legacy/New)"
          />
        </div>
        {isNewServer && (
          <div style={{ display: 'flex', marginTop: 10 }}>
            <button 
              onClick={triggerMigration}
              style={{ padding: '10px 15px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', width: '100%' }}
            >
              ⚠️ Run full CouchDB Migration
            </button>
          </div>
        )}
      </div>
      
      {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
      {loading ? (
        <div>Loading...</div>
      ) : (
        <PowerfulTable
          data={pupils}
          types={{
            _id: { name: 'email' },
            subscription: { name: 'abonnement' }
          }}
          redirect={'pupils'}
          redirectKey={'_id'}
        />
      )}
    </div>
  );
};

const Migration = () => {
  return (
    <div style={{ marginLeft: 20, width: '100%', height: '100%', paddingRight: 20 }}>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2>Migration Dashboard</h2>
      </div>
      
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
        <ServerList title="Old Server (Axepta)" defaultUrl="51.38.179.110" />
        <ServerList title="New Server (Stripe)" defaultUrl="test.expliquemoipythagore.fr" isNewServer={true} />
      </div>
    </div>
  );
};

export default Migration;
